import PopupComponent from '@components/std-components/Popup'
import '@styles/Icon/size-one-icons.css'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from '@material-ui/core/Tooltip'
import { CNFGroupByContainer } from '../../../modules/showroom/CNFGroupBy/CNFGroupByContainer'
import { useObserver } from 'mobx-react-lite'
import MaterialUIBadge from '@material-ui/core/Badge'
import { GroupByIcon } from '@core'

export const GroupByPopup: FC<{
  popupProps: any
  groupByProps: any
}> = ({ popupProps, groupByProps }) => {
  return useObserver(function useHook() {
    const { t } = useTranslation()
    const { onClose } = popupProps
    const { addedGroupByAttributes } = groupByProps?.cnfGroupByUIStore
    const popupHeight = 160 + 120 * (addedGroupByAttributes?.length || 1)
    const { isCustomGroupingApplied } = groupByProps?.cnfGroupByUIStore

    return (
      <PopupComponent
        trigger={
          <div>
            <Tooltip title={t('common.label.groupBy', 'Group By')}>
              <MaterialUIBadge
                variant='dot'
                invisible={!isCustomGroupingApplied}
                color='primary'
              >
                <GroupByIcon />
              </MaterialUIBadge>
            </Tooltip>
          </div>
        }
        contentStyle={{
          width: '420px',
          height: `${popupHeight}px`,
          maxHeight: '85%',
          padding: 0,
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)'
        }}
        nested={true}
        {...popupProps}
      >
        <CNFGroupByContainer {...groupByProps} onClose={onClose} />
      </PopupComponent>
    )
  })
}
